"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var tProps = {
  radio: {
    name: "RADIO_BUTTON_RADIO",
    description: "Radio button style",
    type: _themeContants.themePropTypes.style
  },
  label: {
    name: "RADIO_BUTTON_LABEL",
    description: "Label style",
    type: _themeContants.themePropTypes.style
  },
  wrapper: {
    name: "RADIO_BUTTON_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  }
};

var Radio = _styledComponents["default"].input.withConfig({
  displayName: "RadioButton__Radio",
  componentId: "lh47dh-0"
})(["position:absolute;clip:rect(0,0,0,0);clip:rect(0 0 0 0);&:checked ~ label::after{transform:scale(1);}", ";"], (0, _theming.applyVariants)(tProps.radio));

var Label = _styledComponents["default"].label.withConfig({
  displayName: "RadioButton__Label",
  componentId: "lh47dh-1"
})(["position:relative;padding:0 0 0 ", ";width:auto;letter-spacing:normal;font-family:", ";font-size:", ";font-weight:", ";cursor:pointer;&::before{content:\"\";position:absolute;top:-4px;left:0;display:block;width:", ";height:", ";border:1px solid ", ";border-radius:50%;background:", ";}&::after{content:\"\";position:absolute;top:0px;left:4px;display:block;width:16px;height:16px;border-radius:50%;background-color:", ";line-height:20px;transform:scale(0);transition:all 0.2s ease-in-out;}", ";"], _theming.spacing.mediumPlus, _theming.fontFamily.body, _theming.font.base, _theming.fontWeight.normal, _theming.spacing.medium, _theming.spacing.medium, _theming.color.line, _theming.color.white, _theming.color.primary, (0, _theming.applyVariants)(tProps.label));

var RadioWrapper = _styledComponents["default"].div.withConfig({
  displayName: "RadioButton__RadioWrapper",
  componentId: "lh47dh-2"
})(["min-height:", ";padding-top:", ";padding-bottom:", ";&:hover,", ":focus ~{", "{&::before{border-color:", ";}}}", ";"], _theming.targetSize.normal, _theming.spacing.small, _theming.spacing.small, Radio, Label, _theming.color.wcag, (0, _theming.applyVariants)(tProps.wrapper));

var RadioButton = function RadioButton(_ref) {
  var children = _ref.children,
      id = _ref.id,
      group = _ref.group,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, ["children", "id", "group", "disabled", "onChange", "className", "defaultChecked", "variant"]);

  return _react["default"].createElement(RadioWrapper, {
    className: className,
    variant: variant
  }, _react["default"].createElement(Radio, _extends({
    id: id,
    disabled: disabled,
    type: "radio",
    name: group,
    onChange: onChange,
    defaultChecked: defaultChecked,
    variant: variant
  }, otherProps)), _react["default"].createElement(Label, {
    htmlFor: id,
    variant: variant
  }, children));
};

RadioButton.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string,
  defaultChecked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  group: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  input: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object])
};
RadioButton.defaultProps = {
  className: "",
  defaultChecked: false,
  disabled: false,
  input: {},
  onChange: null,
  value: ""
};
RadioButton.themeProps = tProps;
var _default = RadioButton;
exports["default"] = _default;